<template>
    <div class="create-pdf">
        <vue-html2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="false"
            :preview-modal="true"
            :paginate-elements-by-height="2800"
            filename="Diploma digital"
            :pdf-quality="2"
            :manual-pagination="true"
            pdf-format="letter"
            pdf-orientation="landscape"
            pdf-content-width="100%"

            @beforeDownload="beforeDownload($event)"
            ref="html2Pdf"
        >
            <section slot="pdf-content">
                <DefaultTemplate v-if="certData.template == 'default' || certData.template == undefined" v-bind:name="certData.name" v-bind:lastname="certData.lastname" v-bind:course="certData.course" v-bind:signDate="signDate" v-bind:verifyUrl="this.verifyUrl" v-bind:effort="certData.effort"/>
                <Mype v-if="certData.template == 1" v-bind:name="certData.name" v-bind:lastname="certData.lastname" v-bind:course="certData.course" v-bind:signDate="signDate" v-bind:verifyUrl="this.verifyUrl" v-bind:effort="certData.effort"/>
                <Profxxi v-if="certData.template == 2" v-bind:name="certData.name" v-bind:lastname="certData.lastname" v-bind:course="certData.course" v-bind:signDate="signDate" v-bind:verifyUrl="this.verifyUrl" v-bind:effort="certData.effort"/>
            </section>
        </vue-html2pdf>
    </div>
</template>

<script>
import firebase from "firebase/app"
import 'firebase/app'
import 'firebase/firestore'
import 'firebase/storage'
import VueHtml2pdf from 'vue-html2pdf'
const openpgp = require("openpgp")
import { mapGetters } from 'vuex'
import DefaultTemplate from "../templates/DefaultTemplate.vue"
import Mype from "../templates/Mype.vue"
import Profxxi from "../templates/Profxxi.vue"

export default {
    name: "PdfTemplateCreate",
    props: ['printPdf'],
    data() {
        return {
            verifyUrl: "",
            courseDoc: "",
            signDate: ""
        }
    },
    computed: {
        ...mapGetters({
            currentUser: 'currentUser',
            certData: 'pdfCertificate'
        })
    },
    watch: {
        printPdf: function(newVal, oldVal) {
            this.generateCert()
        }
    },
    methods: {
        async getKeys() {
            let currentKeys = {}
            let configRef = await firebase.firestore().collection("config").doc('general2020')
            let doc = await configRef.get()

            if (doc.data().privateKey && doc.data().publicKey) {
                currentKeys.privateKey = doc.data().privateKey
                currentKeys.publicKey = doc.data().publicKey
            } else {
                currentKeys.privateKey = ""
                currentKeys.publicKey = ""
            }

            return currentKeys
        },
        generateCert() {
            this.verifyUrl = "https://"+window.location.hostname+'/verify/'+this.certData.id+'.'+this.certData.courseId
            let dateVar = new Date(this.certData.issued.seconds * 1000)
            let months = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic']
            let months2 = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre']
            let year = dateVar.getFullYear()
            let month = months[dateVar.getMonth()]
            let date = dateVar.getDate()
            this.signDate = date + ' ' + month + ' ' + year
            if (this.certData.template === "2") {
              month = months2[dateVar.getMonth()]
              this.signDate = date + ' de ' + month + ' ' + year
            } else if (this.certData.template === "3") {
              month = months2[dateVar.getMonth()]
              this.signDate = date + ' ' + month + ' ' + year
            }
            this.$refs.html2Pdf.generatePdf()
        },
        async beforeDownload ({ html2pdf, options, pdfContent }) {
            options.html2canvas.allowTaint = true
            options.html2canvas.useCORS = true
            options.html2canvas.scrollX = 0
            options.html2canvas.scrollY = 0
            options.html2canvas.height = 815
            options.html2canvas.logging = false;
            if (this.certData.template === "2") {
              options.image.quality = "1"
              options.html2canvas.scale = 5
              options.html2canvas.height = 816
            }
            let storageRef = firebase.storage().ref('certificates').child(`${this.certData.name}-${this.certData.lastname}-${this.certData.id}.pdf`);
            let certString = await html2pdf().from(pdfContent).set(options).toPdf().output('datauristring')
            // var viewport = page.getViewport(scale2)
            let certDoc = await storageRef.putString(certString, 'data_url')
            let certDownloadUrl = await certDoc.ref.getDownloadURL()
            let data = {"certUri": certDownloadUrl, "status": 1}

            pdfContent = undefined
            options = ""
            await this.generateSign(certString, data)
        },
        async generateSign(certFile, dataI) {
            let storageSigRef = firebase.storage().ref('signatures').child(this.certData.id+'.sig');
            const userKeys = await this.getKeys()
            const publicKeyArmored = userKeys.publicKey
            const privateKeyArmored = userKeys.privateKey

            const { data: encrypted } = await openpgp.encrypt({
                message: openpgp.message.fromText(certFile),
                publicKeys: (await openpgp.key.readArmored(publicKeyArmored)).keys
            })
            let sigDoc = await storageSigRef.putString(encrypted)
            let sigDownloadUrl = await sigDoc.ref.getDownloadURL()
            let data = {"sigUri": sigDownloadUrl, ...dataI}
            this.updateCertItem(this.certData.id, data, this.certData.courseId)
            //await this.sendEmail(this.certData.id, this.certData.courseId)
            return;
        },
        updateCertItem(docId, item, course = 0) {
          let refCertificate = firebase.firestore().collection("entities").doc(course).collection("certificates").doc(docId);
          refCertificate.update(item);
        },
        async sendEmail(userId, courseId, tried = 1 ){
          if (tried <= 3) {
            let statusSend = await this.$store.getters.sendEmail(userId, courseId);
            if (statusSend == 1) {
              this.$toasted.show(`Diploma enviado correctamente`)
            } else {
            //Intentar enviar 3 veces
              this.$toasted.show(`Error al enviar, intento ${tried}/3`, {type: "error", duration : null})
              this.sendEmail(userId, courseId, (tried + 1));
            }
          }
          this.verifyUrl = ""
          return ;
        }
    },
    components: {
        VueHtml2pdf,
        DefaultTemplate,
        Mype,
        Profxxi
    }
}
</script>



// WEBPACK FOOTER //
// src/components/CreatePdf.vue